import { useState, useEffect, useReducer, useContext } from "react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";
import { toastErrorFixed } from "../../errors/toastErrorSocket";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex] = whatsApp;
			return [...state];
		} else {
			return [whatsApp, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);
	const { user } = useContext(AuthContext);

	useEffect(() => {

		let isMounted = true;
		setLoading(true);
		const fetchSession = async () => {
			try {
				const { data } = await api.get("/whatsapp/");

				if(isMounted) {
					dispatch({ type: "LOAD_WHATSAPPS", payload: data });
					setLoading(false);
				}
			} catch (err) {
				setLoading(false);
				toastError(err);
			}
		};
		fetchSession();

		return () => {isMounted = false;}

	}, []);

	useEffect(() => {
		const socket = openSocket();

		socket.on("whatsapp", data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
			}
		});

		socket.on("whatsapp", data => {
			if (data.action === "delete") {
				dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
			}
		});

		socket.on("whatsappSession", data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		});

		// notification usuário alteração
		socket.on("user", (data) => {
			if (data.action === "update") {
				if (user.id === data.user.id){
					toastErrorFixed('Recarregue a página do navegador por gentileza para aplicar atualizações!!');
				}	
			}
		});

		// notification usuário Ticket
		socket.on("rticket", (data) => {
			if (data.action === "update") {
				if (user.id && user.id === data?.rticket?.userExecute?.id){
					toastErrorFixed(`Ticket ID ${data?.rticket?.id} - Titulo: ${data?.rticket?.title}, vinculado... ${data?.rticket?.userExecute?.name}`);
				}
			}
		});

		return () => {
			socket.disconnect();
		};

		// eslint-disable-next-line
	}, []);

	return { whatsApps, loading };
};

export default useWhatsApps;
